import { memo } from 'react';

function PreviewIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
			{...props}
		>
			<path
				fill="#A6A6A6"
				d="m15.347 3.201-2.25-2.25a.845.845 0 0 0-1.195 0l-6.75 6.75a.84.84 0 0 0-.246.597v2.25a.844.844 0 0 0 .844.844H8a.84.84 0 0 0 .597-.247l6.75-6.75a.845.845 0 0 0 0-1.194M12.5 2.744l1.055 1.054-.774.774-1.054-1.055zm-4.852 6.96H6.594V8.65l3.937-3.938 1.055 1.055zm7.383-.522v4.741a1.406 1.406 0 0 1-1.406 1.406H2.375a1.406 1.406 0 0 1-1.406-1.406V2.673a1.406 1.406 0 0 1 1.406-1.406h4.741a.844.844 0 0 1 0 1.687h-4.46v10.688h10.688v-4.46a.843.843 0 1 1 1.687 0"
			></path>
		</svg>
	);
}

export default memo(PreviewIcon);
